import {GET_WALLET_BALANCE_SUCCESS,GET_WALLET_BALANCE_ERROR,GET_WALLET_BALANCE_RESET} from '../actionTypes';


export const walletInitialState = {
    balance: '',
    updatedAt: '',
    error: null,
}

export default (state = walletInitialState, action) => {
    switch (action.type) {
        case GET_WALLET_BALANCE_SUCCESS:
            return {
                ...state,
                balance: action.payload,
              };
        case GET_WALLET_BALANCE_RESET:
            return { ...state, ...walletInitialState };
        case GET_WALLET_BALANCE_ERROR:
            return { ...state, ...action.payload };
        default: return state;
    }

}